import { render, staticRenderFns } from "./FontModal.vue?vue&type=template&id=459b80ed&scoped=true"
import script from "./FontModal.vue?vue&type=script&lang=js"
export * from "./FontModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459b80ed",
  null
  
)

export default component.exports